import React, { Component } from 'react';
import { Image, Loader, Segment, Divider, Grid, Header, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';
import { doLoginV3, getPublicKey, generateLoginOTPEmail, verifyLoginOTPEmail, setRemindUpdatePassword,getAppLaunchAction,disableShowCovidMsg,enableShowCovidMsg, updateUserProfileChangePassword } from '../../actions';

import './login_page.css';
import FormsLogin from '../../component/forms/login/forms_login';

import GroupCareLogoHorImage from './groupcare_logo_hor.jpg';
import WebImageEditImage from './web_image_edit.jpg';
import ModalDialog from '../../component/widgets/modalDialog/ModalDialog';
import moment from 'moment'

import {
    SECURITY_AND_PRIVACY_STATEMENT,
    WEBSITE_TERMS_AND_CONDITIONS,
    PDPA_STATEMENT,
    ENQUIRY_EMAIL_MHC,
    ENQUIRY_EMAIL_SUBJECT,
    ENQUIRY_EMAIL_BODY_STRING,
} from '../../constants';

class LoginPage extends Component { 
    state={
        launchMessageVisible:false
    }
    

    componentDidMount() {
        this.props.getPublicKey();
        this.props.getAppLaunchAction().then(()=>{
            this.props.enableShowCovidMsg()
            if (this.props.appLaunch.showCovidMsg){ 
                this.showLaunchMessage(this.props.appLaunch.appLaunch) ? this.setState({launchMessageVisible: true}) : this.setState({launchMessageVisible: false})
            }
        })

       
        
        this.checkUserType(this.props.userData)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.checkUserType(this.props.userData)
    }

    checkUserType(userData) {
        if (userData && userData.status === 100 && userData.accessToken) {

            // Get redirect url from query params
            let urlSearch = new URLSearchParams(this.props.history.location.search);
            let redirectLink = urlSearch.get("redirect");

            if (userData.userType === 'sys-admin') {
                if(redirectLink){
                    this.props.history.push(redirectLink);
                }else{
                    this.props.history.push('/systemadmin');
                }
            } else {
                if(redirectLink && !redirectLink.startsWith('/systemadmin')){
                    this.props.history.push(redirectLink);
                }else{
                    this.props.history.push('/app');
                }
            }
        }
    }

    renderLinks() {
        console.log(this.props.appLaunch,'PROPS LOGIN')
        return (
            <div>
                <p>
                    <Link to="/register">
                        Register Your Account
                    </Link>
                </p>
                <p>
                    <Link to="/forgetpassword">
                        Forgot Password
                    </Link>
                </p>
                <p>
                    <Link to="/recoveraccount">
                        Recover Account
                    </Link>
                </p>
                <p>
                    <a href={ "mailto:" + ENQUIRY_EMAIL_MHC + "?subject=" + ENQUIRY_EMAIL_SUBJECT + "&body=" + ENQUIRY_EMAIL_BODY_STRING }>Email Us</a>
                </p>
            </div>
        )
    }

    renderTermsAndConditions() {
        return (
            <div>
                <a href={ SECURITY_AND_PRIVACY_STATEMENT } target='blank'> Security and Privacy Statement </a>
                |
                <a href={ WEBSITE_TERMS_AND_CONDITIONS } target='blank'> Website Terms and Conditions </a>
                |
                <a href={ this.props.appLaunch && this.props.appLaunch.appLaunchExtra ? this.props.appLaunch.appLaunchExtra.production_url_pdpa : PDPA_STATEMENT } target='blank'> Personal Data Use Statement </a>
            </div>
        )
    }

    renderAllRightReserved(){
        return (
            <div>
                { new Date().getFullYear() + " All rights reserved" }
            </div>
        )
    }

    renderInfoDialog(){
        // Get url query params
        let urlQueryParam = new URLSearchParams(this.props.history.location.search);
        if(urlQueryParam.get("info")){
            return <Message info>{urlQueryParam.get("info")}</Message>
        }
    }

    showLaunchMessage(message){ 
        if (message && message.publish){ 
            if (message.startDate && message.endDate){
                var now = Date.now(); 
                if (now >= moment(message.startDate, "YYYY-MM-DD hh:mm:ss") && now < moment(message.endDate, "YYYY-MM-DD hh:mm:ss")) { 
                    return true;
                } else { 
                    return false;
                }
            }
            if (message.startDate && !message.endDate){
                var now = Date.now(); 
                if (now >= moment(message.startDate, "YYYY-MM-DD hh:mm:ss")) { 
                    return true;
                } else { 
                    return false;
                }
            }
            if (!message.startDate && message.endDate){
                var now = Date.now(); 
                if (now < moment(message.endDate, "YYYY-MM-DD hh:mm:ss")) { 
                    return true;
                } else { 
                    return false;
                }
            }
            return true;
       }
       return false;
    }

    disableCovidMsg(){ 
        this.setState({
            launhcMessageVisible:false
        },()=> this.props.disableShowCovidMsg())
    }

    render() { 
        if (!this.props.publicKey) {
            return <Loader active />
        }

        return (
            <div style={{ position: 'absolute', width: '100%', height: '100%' }}>
                <Grid style={{ height: '100%', margin: 0, backgroundImage: `url(${WebImageEditImage})`, backgroundSize: 'cover' }}>
                    <Grid.Row>
                        <Grid.Column floated='left' style={{ width: '480px' }}>
                            {this.renderInfoDialog()}
                        </Grid.Column>
                        <Grid.Column floated='right' style={{ width: '480px' }}>
                            <Segment padded='very'>
                                <Image src={GroupCareLogoHorImage} size="medium" centered style={{ paddingTop: '1em', paddingBottom: '4em' }} alt='Group Care Income'/>
                                {this.state.launchMessageVisible && this.props.appLaunch && this.props.appLaunch.appLaunch && this.props.appLaunch.appLaunch.message?<ModalDialog
                                    title={this.props.appLaunch.appLaunch.title?this.props.appLaunch.appLaunch.title:null}
                                    open={this.props.appLaunch.showCovidMsg} 
                                    description={this.props.appLaunch.appLaunch.message}
                                    btnYesText="Okay" 
                                    btnYesAction={(function(){
                                        this.props.disableShowCovidMsg()
                                    }).bind(this)} 
                                />:null} 
                                <FormsLogin
                                    history={this.props.history}
                                    user={this.props.userData}
                                    doLogin={this.props.doLoginV3}
                                    generateLoginOTPEmail={this.props.generateLoginOTPEmail}
                                    verifyLoginOTPEmail={this.props.verifyLoginOTPEmail}
                                    setRemindUpdatePassword={this.props.setRemindUpdatePassword}
                                    updateUserProfileChangePassword={this.props.updateUserProfileChangePassword}
                                />
                                <div style={{ paddingTop: '20px' }}>
                                    { this.renderLinks() }
                                    <Divider/>
                                    { this.renderTermsAndConditions() }
                                    <Header size="tiny" disabled> { this.renderAllRightReserved() } </Header>
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
              
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
    userData: state.user.user,
    publicKey: state.appConfig.publicKey,
    appLaunch: state.appLaunchConfig
  };
}

export default withRouter(connect(mapStateToProps, { doLoginV3, getPublicKey, generateLoginOTPEmail, verifyLoginOTPEmail, setRemindUpdatePassword,getAppLaunchAction,disableShowCovidMsg,enableShowCovidMsg, updateUserProfileChangePassword })(LoginPage));
